import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=69b0d12b&scoped=true&"
import script from "./Licenses.vue?vue&type=script&lang=js&"
export * from "./Licenses.vue?vue&type=script&lang=js&"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=69b0d12b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b0d12b",
  null
  
)

export default component.exports